import styled from "styled-components";

const Style = styled.div`
  width: 80%;
  position: relative;

  animation: 0.5s minHeightAnimation forwards;

  @keyframes minHeightAnimation {
    0% {min-height: 400px;}
    100% {min-height: 0px;}
  }
  
  .label {
    position: absolute;
    font-size: 12px;
  }

  .label-a {
    top: 5%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .label-b {
    top: 35%;
    right: 5%;
    transform: translate(50%, 0%);
  }

  .label-c {
    top: 84%;
    right: 24%;
    transform: translate(50%, 0%);
  }

  .label-d {
    top: 84%;
    left: 20%;
  }

  .label-e {
    top: 35%;
    left: 1%;
    transform: translate(-50%, 0%);
  }
`;

export default Style;
